import { api } from "../Apis/interceptor";

export const getCustomerFields = function (id) {
  return api.get(`/api/v1/customer/${id}`);
};

export const addNewField = function (id) {
  return api.post(`api/v1/addNewField/${id}`);
};

export const getCustomerFields2 = function (id) {
  return api.get(`/api/v1/customerField/${id}`);
};

// export  const getCustomerOpportunity = function(id){
//    return api.get(`/api/v1/getOppList/${id}`);
// }

// export  const getClientList = function(id){
//    return api.get(`/api/v1/getClientList/${id}`);
// }

export const getExternalUsers = function (id) {
  return api.get(`/api/v1/getExternalUsers?cust_id=${id}`);
};
export const getExternalUsersName = function (id,val) {
  return api.get(`/api/v1/getExternalUsers`,{
    params: {
      cust_id: id,
      searchVal: val,
    }
  });
};
